import { Component, Inject, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { IWorkflowStatusCCNViewModel } from 'src/app/ViewModel/WorkflowStatusModel';

@Component({
  selector: 'app-workflow-status-ccn-dialog',
  templateUrl: './workflow-status-ccn-dialog.component.html',
  styleUrls: ['./workflow-status-ccn-dialog.component.css']
})
export class WorkflowStatusCCNDialogComponent implements OnInit {
  selectedCCNDetails!: IWorkflowStatusCCNViewModel[];
  doc_No!: string;
  pageSize :number= 20;

  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public workflowTemplateService: WorkflowTemplateService, public _dialogRef: MatDialogRef<WorkflowStatusCCNDialogComponent>) { }

  ngOnInit() {
    this.doc_No = this.data.doc_No
    this.getChangControlDetails();
  }

  getChangControlDetails() {
    this.workflowTemplateService.GetWorkflowStatusCCNDetails(this.data.doc_Id).subscribe((data:IWorkflowStatusCCNViewModel[]) => { this.selectedCCNDetails = data;});

  }

  closeDialog() {
    this._dialogRef.close();
  }

 

}
